import React from 'react';
import { Link } from 'react-router-dom';
export function AngelikaSturnFooter() {
  return <footer id="kontakt" className="w-full py-12 px-6 md:px-12 bg-gray-100" data-id="element-58">
      <div className="max-w-4xl mx-auto" data-id="element-59">
        <div className="p-6 rounded-lg flex flex-col md:flex-row gap-6" data-id="element-60">
          <div className="flex-shrink-0" data-id="element-61">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qPSh5jJHMvyuJqwzE92tue/Angelika_Sturny-v3.jpg" alt="Dr. Angelika Sturny" className="rounded-lg shadow-md h-64 w-auto object-cover" data-id="element-62" />
          </div>
          <div className="flex-grow flex flex-col" data-id="element-63">
            <h3 className="text-xl font-medium text-gray-700 mb-3" data-id="element-64">Kontakt</h3>
            <p className="text-gray-600 mb-1 leading-tight" data-id="element-65">
              Dr. Dipl.-Psych. Angelika Sturny
            </p>
            <p className="text-gray-600 mb-2 leading-tight" data-id="element-66">
              Diplom-Psychologin
            </p>
            <p className="text-gray-600 mb-2 leading-tight" data-id="element-67">
              85540 Haar bei München
            </p>
            <p className="text-gray-600 mb-4 leading-tight" data-id="element-68">
              E-Mail:{' '}
              <a href="mailto:praxis@angelikasturny.com" className="hover:text-[#cda8be] hover:font-semibold transition-colors" data-id="element-69">
                praxis@angelikasturny.com
              </a>
            </p>
            <p className="text-gray-600 mb-4 leading-tight" data-id="element-70">
              Lassen Sie uns sprechen – ich freue mich auf Sie!
            </p>
            <Link to="/angelika_sturny/termin-vereinbaren" className="block w-full mt-auto" data-id="element-71">
              <button className="w-full py-3 px-6 text-gray-700 rounded-md hover:font-semibold transition-colors" style={{
              backgroundColor: '#cda8be'
            }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#b88fa8'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#cda8be'} data-id="element-72">
                Termin vereinbaren
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-gray-200" data-id="element-73">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-74">
          <div className="mb-4 md:mb-0" data-id="element-75">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sBeLHqEvA69hG4RGUSQpxM/Logo-Schifferer_Sturny-final2.png" alt="Praxis für Beratung und Psychotherapie Logo" className="h-12" data-id="element-76" />
          </div>
          <div className="flex flex-col md:flex-row items-center text-gray-500 text-sm" data-id="element-77">
            <div className="flex space-x-4 mb-2 md:mb-0 md:mr-4" data-id="element-78">
              <Link to="/datenschutz" className="hover:text-[#cda8be] transition-colors" data-id="element-79">
                Datenschutz
              </Link>
              <Link to="/impressum" className="hover:text-[#cda8be] transition-colors" data-id="element-80">
                Impressum
              </Link>
            </div>
            <div data-id="element-81">
              © {new Date().getFullYear()} Praxis für Beratung und
              Psychotherapie. Alle Rechte vorbehalten.
            </div>
          </div>
        </div>
      </div>
    </footer>;
}